import { render, staticRenderFns } from "./cLoading.vue?vue&type=template&id=3ed45ee6&scoped=true&lang=pug"
import script from "./cLoading.vue?vue&type=script&lang=js"
export * from "./cLoading.vue?vue&type=script&lang=js"
import style0 from "./cLoading.vue?vue&type=style&index=0&id=3ed45ee6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed45ee6",
  null
  
)

export default component.exports